import * as React from 'react';
import _ from 'lodash';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { IFileUploadProps } from 'sos-common/js/components/Fileupload/Fileupload.types';
import { DeleteButton } from 'sos-eservice-common/js/components/General/DeleteButton';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { setInnerHtml } from 'sos-common/js/utils/helpers';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { TextInput, TextInputProps } from 'sos-common/js/components/FormControls/TextInput';
import { CheckBox, CheckBoxState, CheckBoxProps } from 'sos-common/js/components/FormControls/CheckBox';
import { SelectBox, SelectBoxProps } from 'sos-common/js/components/FormControls/SelectBox';
import { SkyddadYrkestitelAnsokan, SkyddadYrkestitelPayload } from '../../../models/skyddadyrkestitel.model';
import AttentionBox from 'sos-common/js/components/AttentionBox/Attentionbox';

import {
  ISkyddadYrkestitelAnsokanFormProps,
  ISkyddadYrkestitelAnsokanFormState,
} from './SkyddadYrkestitelAnsokanForm.types';
import { LegAnsokanFormFieldName, LegAnsokanField, Yrke } from '../LegAnsokanForm.types';

import { FormField, FormFieldFile, FormFieldProps } from 'sos-common/js/commonTypes/formField.types';
import LoadingSpinner from 'sos-common/js/components/LoadingSpinner/LoadingSpinner';
import { FileExtendedDetails, FileState } from 'sos-common/js/commonTypes/fileupload.types';
import { doDelete, doGet, doPost } from 'sos-eservice-common/js/services/fetch.service';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import { DialogueError } from 'sos-common/js/components/DialogueError/DialogueError';
import { getDialogueByResponse } from '../../../helpers/dialogue.helper';
import { SkyddadYrkestitelFieldMap } from './SkyddadYrkestitelFieldMap';
import { FileUploadText, FolkbokforingsAdress } from '../../../models/ansokan.model';
import { saveAnsokan } from '../../../services/ansokanform.save.service';
import { MultiSelectItem } from 'sos-common/js/commonTypes/multiSelect.types';
import { findFileUploadTextByFieldName, getFileUploadTexts } from '../../../helpers/fileUploadHelpers';

let ModalTranslate: (key: string, defaultValue?: string) => string;
let Translations: (key: string, defaultValue?: string) => string;

export class SkyddadYrkestitelAnsokanForm extends React.Component<
  ISkyddadYrkestitelAnsokanFormProps,
  ISkyddadYrkestitelAnsokanFormState
> {
  private _latestResponseError: ResponseError;
  private _mandatoryText: string;
  private _folkbokforing: FolkbokforingsAdress = null;
  private _yrkesbehorighetInformationText = null;
  private readonly API_ROUTE = '/_api/yrkestitel';
  constructor(props: ISkyddadYrkestitelAnsokanFormProps) {
    super(props);

    ModalTranslate = makeTranslator(props.modalTranslations);
    Translations = makeTranslator(props.translations);
    this._mandatoryText = Translations('mandatory');
    const fieldMap = new SkyddadYrkestitelFieldMap(
      props.model,
      props.ansokan,
      props.formTexts,
      props.educatedInSweden,
      Translations,
      this.addFile,
      this.removeFile,
      this.addMultiSelectItem
    );
    fieldMap.addOnChangeEventHandler(this.inputChanged, this.onChangeTermsAndCondition);

    const currentUtbildningsForm =
      this.props.ansokan.Utbildning.UtbildningsformId != null && this.props.ansokan.Utbildning.UtbildningsformId !== ''
        ? this.props.model.Utbildningsform.filter(
            (x) => x.Utbildningsform.Id === this.props.ansokan.Utbildning.UtbildningsformId
          )[0]
        : null;

    this._yrkesbehorighetInformationText = currentUtbildningsForm?.ExtraInformationText;

    this.state = {
      fieldMap,
      payload: this.getDefaultPayload(props.ansokan),
      showSpinner: false,
      isLoading: false,
      isSaveErrorModalOpen: false,
      showAddressInfo: false,
      certInOtherCountry: this.props.ansokan.Utbildning.BehorighetsbevisFranAnnatLand ?? false,
      utbildningsperioder:
        currentUtbildningsForm !== null
          ? this.props.model.Utbildningsform.filter(
              (x) => x.Utbildningsform.Id === this.props.ansokan.Utbildning.UtbildningsformId
            )[0].Utbildningsperiod
          : [],
    };
  }

  componentDidMount() {
    let mailfields = document.querySelectorAll('#Epost,#BekraftaEpost');

    //.foreach() does not work in IE
    for (let index = 0; index < mailfields.length; index++) {
      const element = mailfields[index];
      element.addEventListener('paste', (e: ClipboardEvent) => {
        e.preventDefault();
      });
    }
  }

  onChangeTermsAndCondition = (field: CheckBoxState) => {
    const fieldMap = this.state.fieldMap.clone();
    const fieldState = fieldMap.get(LegAnsokanFormFieldName.TermsAndConditions);
    fieldState.props.value = field.value;
    fieldMap.validateAllFieldsWithErrorMessages();
    this.setState({ fieldMap: fieldMap.clone() });
  };

  getDefaultPayload = (ansokan: SkyddadYrkestitelAnsokan): SkyddadYrkestitelPayload => {
    return {
      AnsokanId: ansokan.Id,
      UtbildningslandId: ansokan.Utbildning?.UtbildningslandId ?? null,
      BehorighetsbevisFranAnnatLand: ansokan.Utbildning?.BehorighetsbevisFranAnnatLand ?? null,
      UtbildningsPeriodId: ansokan.Utbildning?.UtbildningsperiodId ?? null,
      Epost: ansokan.Epost ?? null,
      AccepteratVillkor: ansokan.AccepteratVillkor ?? null,
      YrkeId: this.props.model.OccupationId,
    };
  };

  //we _probably_ don't need to trigger an extra update call here
  onGranskaOchBetalaClick = () => {
    const ansokanId = this.props.ansokan.Id;
    window.location.href = `/${this.props.stepTwoPageLink}/?ansokanId=${ansokanId}`;
  };

  addMultiSelectItem = (selectedItems: MultiSelectItem[]) => {
    const { fieldMap, payload } = this.state;
    payload[LegAnsokanFormFieldName.OtherCertCountries] = selectedItems.map((x) => x.key);
    const fieldState = fieldMap.get(LegAnsokanFormFieldName.OtherCertCountries);
    fieldState.props.value = selectedItems.map((x) => x.key);

    fieldMap.validateFieldWithErrorMessage(fieldState);

    this.setState(
      {
        fieldMap: fieldMap.clone(),
        payload,
        showSpinner: true,
        isLoading: true,
      },
      () => {
        let partialState = {} as ISkyddadYrkestitelAnsokanFormState;
        saveAnsokan(this.state.payload, this.API_ROUTE).then((response) => {
          if (response instanceof ResponseError) {
            this._latestResponseError = response;
            partialState.isSaveErrorModalOpen = true;
          } else {
            this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
            partialState.isSaveErrorModalOpen = false;
          }

          this.setState({
            showSpinner: false,
            isLoading: false,
            ...partialState,
          });
        });
      }
    );
  };

  _removeNonExistingFileFromList = () => {
    const fieldMap = this.state.fieldMap.clone();
    fieldMap.removeAllNonExistingFields();
    this.setState({ fieldMap });
  };

  _setPreFileSaveStateInGui = (
    fieldMap: SkyddadYrkestitelFieldMap,
    file: FileExtendedDetails,
    field: FormFieldFile
  ) => {
    file.FileId = null; //trigger the loading file spinner.
    file.status = FileState.UPLOADING;

    this.updateFileState(fieldMap, field);
    fieldMap.setFileErrorMessage(null, field.fieldName);
  };

  updateFileState = (fieldMap: SkyddadYrkestitelFieldMap, field: FormFieldFile) => {
    fieldMap.setFileValueByFieldName(field);
    const fieldState = fieldMap.get(field.fieldName);
    fieldMap.validateFieldWithErrorMessage(fieldState);
  };

  updateEnableStateForGranskaOchBetalaButton = (fieldMap: SkyddadYrkestitelFieldMap) => {
    //NOTE: although the  fieldMap.validateAllFields could be called directly, it is better to have this intermediate method in order to explain the purpose in the GUI of calling it.
    fieldMap.validateAllFields();
  };

  inputChanged = (field: LegAnsokanField) => {
    const { fieldMap, payload } = this.state;
    let certOtherCountries = null;
    let utbildningsperiod = null;
    let fieldName = '';

    //TODO: Why does field.fieldName for radioButtonGroup come as object? Fix the root cause and remove this ugly check :)
    if (typeof field.fieldName === 'object') {
      let fieldData = field as any;
      fieldName = fieldData.fieldName.fieldName;
    } else {
      fieldName = field.fieldName;
    }
    //ENDTODO

    //Get utbildningsperioder for specific utbildningsform
    if (fieldName === LegAnsokanFormFieldName.EducationForm) {
      //Set payload for educationPeriod to null everytime we change the educationform

      const educationPeriodState = fieldMap.get(LegAnsokanFormFieldName.EducationPeriod);
      const educationFormState = fieldMap.get(LegAnsokanFormFieldName.EducationForm) as any;

      payload[LegAnsokanFormFieldName.EducationPeriod] = null;
      educationPeriodState.props.value = null;
      //if value is empty we need to reset utbildningsperiod
      if (field.value === '') {
        utbildningsperiod = [];
        educationPeriodState.props.isRequired = false;
      } else {
        const utbildningsForm = this.props.model.Utbildningsform.filter((x) => x.Utbildningsform.Id === field.value)[0];

        this._yrkesbehorighetInformationText = utbildningsForm.ExtraInformationText;
        utbildningsperiod = utbildningsForm.Utbildningsperiod;
        if (utbildningsperiod.length === 0) {
          educationPeriodState.props.isRequired = false;
        } else {
          educationPeriodState.props.isRequired = true;
        }
      }
    }

    if (fieldName === LegAnsokanFormFieldName.HasCertInOtherCountry) {
      let otherLegCountry = fieldMap.get(LegAnsokanFormFieldName.OtherCertCountries);

      if (field.value === true) {
        otherLegCountry.props.isRequired = true;
      } else if (field.value === false) {
        otherLegCountry.props.isRequired = false;
        (otherLegCountry.props as any).items = (otherLegCountry.props as any).items.map((x) => ({
          ...x,
          isSelectedByDefault: false,
        }));
        payload[LegAnsokanFormFieldName.OtherCertCountries] = null;
      }
      certOtherCountries = field.value;
    }

    let fieldState = fieldMap.get(fieldName);
    fieldState.props.value = field.value;
    const isValid = fieldMap.validateFieldWithErrorMessage(fieldState);
    if (fieldName === LegAnsokanFormFieldName.DateOfCertificate) {
      if (!isValid) {
        this.setState({ fieldMap: fieldMap.clone() });
        return;
      }
    }

    this.updateEnableStateForGranskaOchBetalaButton(fieldMap);

    if (fieldName === LegAnsokanFormFieldName.ConfirmEmail) {
      this.setState({ fieldMap: fieldMap.clone() });
      return; //We don't save if the confirmation email.
    }

    payload[fieldName] = field.value;

    this.setState(
      {
        fieldMap: fieldMap.clone(),
        payload,
        showSpinner: true,
        isLoading: true,
        certInOtherCountry: certOtherCountries ?? this.state.certInOtherCountry,
        utbildningsperioder: utbildningsperiod ?? this.state.utbildningsperioder,
      },
      () => {
        let partialState = {} as ISkyddadYrkestitelAnsokanFormState;
        saveAnsokan(this.state.payload, this.API_ROUTE).then((response) => {
          if (response instanceof ResponseError) {
            this._latestResponseError = response;

            if (field.fieldName === LegAnsokanFormFieldName.Email) {
              fieldMap.setErrorMessage(response.body.errorMessage, field.fieldName);
            } else {
              partialState.isSaveErrorModalOpen = true;
            }
          } else {
            this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
            partialState.isSaveErrorModalOpen = false;
          }
          this.setState({
            showSpinner: false,
            isLoading: false,
            ...partialState,
          });
        });
      }
    );
  };

  addFile = (field: FormFieldFile) => {
    const { model } = this.props;
    const fieldMap = this.state.fieldMap.clone();
    const file = field.value.filter((f) => !f.FileId)[0];

    this._setPreFileSaveStateInGui(fieldMap, file, field);
    this.setState({ fieldMap, isLoading: true });

    const form = new FormData();
    form.append(file.OriginalFilename, file.file);
    const fileUploadTexts = getFileUploadTexts(model) as FileUploadText;
    const fileUploadText = findFileUploadTextByFieldName(field.fieldName, fileUploadTexts);

    const fileTag = field.fieldName;
    const dhsCategory = fileUploadText?.DHSCategory?.Category;
    const apiPathExtension = `yrkestitel/attachbilaga/${this.props.ansokan.Id.toString()}/${fileTag}/${
      this.props.currentLanguage
    }/${dhsCategory ? dhsCategory : ''}`;
    const path = `/_api/${apiPathExtension}`;
    return doPost<FileExtendedDetails>(path, form)
      .then((response) => {
        const fieldMap = this.state.fieldMap.clone();
        let partialState = {} as ISkyddadYrkestitelAnsokanFormState;
        if (response instanceof ResponseError) {
          this._latestResponseError = response;
          if (response.body.detailCode) {
            partialState.isSaveErrorModalOpen = true;
          } else {
            //only show file error if there is no timeout
            fieldMap.setFileErrorMessage(response.body.errorMessage, field.fieldName);
            this._removeNonExistingFileFromList();
            partialState.isSaveErrorModalOpen = false;
          }
        } else {
          const fileResponse = response as any;
          file.FileId = fileResponse.Id.toString();
          file.status = FileState.SETTLED;
          this.updateFileState(fieldMap, field);
          partialState.isSaveErrorModalOpen = false;
        }
        this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
        this.setState({ fieldMap, isLoading: false, ...partialState });
      })
      .catch((err: ResponseError) => {
        fieldMap.setFileErrorMessage(err.body.errorMessage, field.fieldName); //TODO: Make sure server returns a proper error message to the end user.
        this._removeNonExistingFileFromList();
      });
  };

  removeFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    const fileId = file.FileId;
    const ansokanId = this.props.ansokan.Id;

    const fieldMap = this.state.fieldMap.clone();
    this._setPreFileSaveStateInGui(fieldMap, file, field);
    this.setState({ fieldMap });

    const path = `/_api/yrkestitel/deletefile/${fileId}/${ansokanId}`;

    return doDelete<FileExtendedDetails>(path)
      .then((response) => {
        const fieldMap = this.state.fieldMap.clone();
        let partialState = {} as ISkyddadYrkestitelAnsokanFormState;
        if (response instanceof ResponseError) {
          this._latestResponseError = response;
          if (response.body.detailCode) {
            partialState.isSaveErrorModalOpen = true;
          } else {
            fieldMap.setFileErrorMessage(response.body.errorMessage, field.fieldName);
            file.FileId = fileId;
            file.status = FileState.SETTLED;
            this.updateFileState(fieldMap, field);
            partialState.isSaveErrorModalOpen = false;
          }
        } else {
          const fileResponse = response as any;
          const deletedId = fileResponse.id;
          this._removeNonExistingFileFromList();
          const fieldState = fieldMap.get(field.fieldName);
          fieldMap.validateFieldWithErrorMessage(fieldState);
          partialState.isSaveErrorModalOpen = false;
        }
        this.updateEnableStateForGranskaOchBetalaButton(fieldMap);
        this.setState({ fieldMap, isLoading: false, ...partialState });
        return response;
      })
      .catch((err: ResponseError) => {
        //TODO: Do we need this? I guess it only occurs in case of time out providing that Error handling is done on the server.
        //TODO: Tobias?: Is there a timeout? How is this set in the fetch function?
        fieldMap.setFileErrorMessage(err.body.errorMessage, field.fieldName);
        file.FileId = fileId;
        file.status = FileState.SETTLED;
        this.updateFileState(fieldMap, field);
      });
  };

  onModalClose = () => {
    this.setState({
      isSaveErrorModalOpen: false,
    });
  };

  renderEducatedInSwedenFields = () => {
    return (
      <section aria-label={Translations('educationSectionHeaderInSweden')}>
        <h2>{Translations('educationSectionHeaderInSweden')}</h2>
        <div className="row">
          <div className="col-sm-6">
            <SelectBox {...(this.state.fieldMap.get(LegAnsokanFormFieldName.EducationForm).props as SelectBoxProps)} />
          </div>
        </div>
        {this.state.utbildningsperioder && this.state.utbildningsperioder.length > 0 && (
          <div className="row">
            <div className="col-sm-6">
              {
                <>
                  <RadioButtonGroup {...this.state.fieldMap.get(LegAnsokanFormFieldName.EducationPeriod).props}>
                    {this.state.utbildningsperioder.map((utbPeriod, index) => {
                      return <RadioButton key={utbPeriod.Id} value={utbPeriod.Id} label={utbPeriod.Namn} />;
                    })}
                  </RadioButtonGroup>
                </>
              }
            </div>
          </div>
        )}
        {this._yrkesbehorighetInformationText && (
          <div className="importantinfo importantinfo--lightgray importantinfo--sharp">
            <p>{this._yrkesbehorighetInformationText}</p>
          </div>
        )}
      </section>
    );
  };

  renderEducatedOutsideSwedenFields = () => {
    return (
      <section aria-label={Translations('educationSectionHeader')}>
        <h2>{Translations('educationSectionHeader')}</h2>
        <div className="row m-b-2">
          <div className="col-sm-6">
            <SelectBox
              {...(this.state.fieldMap.get(LegAnsokanFormFieldName.UtbildningsLand).props as SelectBoxProps)}
            />
          </div>
        </div>
        <div className="row m-b-2">
          <div className="col-sm-6">
            <TextInput {...(this.state.fieldMap.get(LegAnsokanFormFieldName.EducationTitle).props as TextInputProps)} />
          </div>
          <div className="col-sm-6">
            <TextInput
              {...(this.state.fieldMap.get(LegAnsokanFormFieldName.EducationLength).props as TextInputProps)}
            />
          </div>
        </div>
        <div className="row m-b-2">
          <div className="col-sm-6">
            <TextInput
              {...(this.state.fieldMap.get(LegAnsokanFormFieldName.ExaminationYear).props as TextInputProps)}
            />
          </div>
          <div className="col-sm-6">
            <TextInput
              {...(this.state.fieldMap.get(LegAnsokanFormFieldName.DateOfCertificate).props as TextInputProps)}
            />
          </div>
        </div>
      </section>
    );
  };
  getAddressInfo = (): JSX.Element => {
    const { formTexts } = this.props;
    const folkbokforing = this._folkbokforing;
    if (folkbokforing) {
      //NOTE: If any error occurs with extracting this info on the server, this object is always null, never otherwise. The server side code takes care of logging the error with information about it.
      return (
        <div className="importantinfo importantinfo--futura m-b-4" aria-label="Dina folkbokföringsuppgifter">
          <div>{folkbokforing.Namn}</div>
          <div>{folkbokforing.PersonNummer}</div>
          {folkbokforing.CareOf && <div>{`c/o ${folkbokforing.CareOf}`}</div>}
          {folkbokforing.Utdelningsadress1 && <div>{folkbokforing.Utdelningsadress1}</div>}
          {folkbokforing.Utdelningsadress2 && <div>{folkbokforing.Utdelningsadress2}</div>}
          <div>
            {folkbokforing.PostNr && <span>{folkbokforing.PostNr}</span>}{' '}
            {folkbokforing.Postort && <span>{folkbokforing.Postort}</span>}
          </div>
        </div>
      );
    }

    return (
      <div className="m-b-4">
        <AttentionBox
          heading={formTexts.PersonuppgifterCouldNotBeLoadedHeading}
          bodytext={formTexts.PersonuppgifterCouldNotBeLoadedBody}
          icon="Info"
          cssClass="attentionbox--red"
        />
      </div>
    );
  };

  onShowAddressClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const path = '/_api/yrkestitel/getfolkbokforing';
    if (!this._folkbokforing) {
      doGet<FolkbokforingsAdress>(path).then((response) => {
        if (response instanceof ResponseError) {
          this._latestResponseError = response;
          if (response.body.detailCode) {
          }
        } else {
          this._folkbokforing = response;
        }
        this.setState((prevState) => {
          return { showAddressInfo: !prevState.showAddressInfo };
        });
      });
    } else {
      this.setState((prevState) => {
        return { showAddressInfo: !prevState.showAddressInfo };
      });
    }
  };

  public render() {
    const { model, formTexts, deleteLink, myPage, educatedInSweden } = this.props;
    const { fieldMap, showSpinner, isLoading, isSaveErrorModalOpen, showAddressInfo } = this.state;

    const fileupload1FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload1);
    const fileupload2FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload2);
    const fileupload3FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload3);
    const fileupload4FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload4);
    const fileupload5FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload5);
    const fileupload6FieldState = fieldMap.get(LegAnsokanFormFieldName.FileUpload6);
    return (
      <>
        {isSaveErrorModalOpen && (
          <DialogueError
            dialogueErrorBody={getDialogueByResponse(this._latestResponseError, myPage, null, Translations)}
            isModalOpen={isSaveErrorModalOpen}
            onModalClose={this.onModalClose}
            enableCloseIcon={false}
            shouldCloseOnOverlayClick={false}
          />
        )}
        <p className="preamble">
          {Translations('skyddadYrkestitel/preamble')}
          <strong>{model.YrkesNamn.toLowerCase()}</strong>{' '}
          {educatedInSweden
            ? Translations('skyddadYrkestitel/educatedInSwedenText')
            : Translations('skyddadYrkestitel/educatedOutsideSwedenText')}
        </p>
        {model.ImportantInformation && (
          <div
            className="importantinfo importantinfo--lightgray importantinfo--sharp"
            dangerouslySetInnerHTML={setInnerHtml(model.ImportantInformation)}
          />
        )}
        <hr />
        {formTexts.PersonuppgifterHeading && <h2>{formTexts.PersonuppgifterHeading}</h2>}
        {formTexts.PersonuppgifterBody && <div dangerouslySetInnerHTML={setInnerHtml(formTexts.PersonuppgifterBody)} />}
        <button className="button button--border m-b-2" onClick={this.onShowAddressClick}>
          {!showAddressInfo ? Translations('showButton') : Translations('hideButton')}{' '}
          {Translations('folkbokforingsadress')}
        </button>
        <div role="log" aria-live="polite">
          {showAddressInfo && this.getAddressInfo()}
        </div>
        <div className="row">
          <div className="col-sm-6">
            <TextInput {...(fieldMap.get(LegAnsokanFormFieldName.Email).props as TextInputProps)} />
          </div>
          <div className="col-sm-6">
            <TextInput {...(fieldMap.get(LegAnsokanFormFieldName.ConfirmEmail).props as TextInputProps)} />
          </div>
        </div>
        <hr />

        {educatedInSweden ? this.renderEducatedInSwedenFields() : this.renderEducatedOutsideSwedenFields()}
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload1) && (
            <>
              <hr />{' '}
              {formTexts.DocumentInfo && !educatedInSweden && (
                <AttentionBox
                  cssClass="attentionbox--brown m-b-2 m-t-2"
                  icon="Infocirkel_normal20px20px"
                  bodytext={formTexts.DocumentInfo}
                />
              )}
              {model.FileUploadText1 && <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText1.IntroText)} />}
              <Fileupload {...(fileupload1FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>

        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload2) && model.FileUploadText2 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText2.IntroText)} />
              <Fileupload {...(fileupload2FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>

        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload3) && model.FileUploadText3 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText3.IntroText)} />
              <Fileupload {...(fileupload3FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>

        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload4) && model.FileUploadText4 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText4.IntroText)} />
              <Fileupload {...(fileupload4FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload5) && model.FileUploadText5 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText5.IntroText)} />
              <Fileupload {...(fileupload5FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        <div role="log" aria-live="polite">
          {fieldMap.showFieldFor(LegAnsokanFormFieldName.FileUpload6) && model.FileUploadText6 && (
            <>
              <hr />
              <div dangerouslySetInnerHTML={setInnerHtml(model.FileUploadText6.IntroText)} />
              <Fileupload {...(fileupload6FieldState.props as IFileUploadProps)} />
            </>
          )}
        </div>
        {model.ExtraInformation && (
          <>
            <hr />
            <div dangerouslySetInnerHTML={setInnerHtml(model.ExtraInformation)} />
          </>
        )}

        <hr />
        <CheckBox {...(fieldMap.get(LegAnsokanFormFieldName.TermsAndConditions).props as CheckBoxProps)} />
        {formTexts.SamtyckeExplanation && <div dangerouslySetInnerHTML={setInnerHtml(formTexts.SamtyckeExplanation)} />}
        <div className="form-submit">
          <button
            className="button relative"
            onClick={this.onGranskaOchBetalaClick}
            disabled={isLoading || !fieldMap.allFieldsAreValid || showSpinner}>
            {Translations('reviewAndPayButton')}
            {showSpinner && <LoadingSpinner cssClasses="button-spinner" />}
          </button>
        </div>
        <hr />
        <div className="delete-order">
          <DeleteButton
            postLink={deleteLink}
            disabled={false}
            actionText={ModalTranslate('delete')}
            cancelText={ModalTranslate('cancel')}
            modalHeading={ModalTranslate('heading')}
            modalBody={ModalTranslate('text')}
            buttonRemoveText={ModalTranslate('delete')}
          />
        </div>
      </>
    );
  }
}
